import { ICellRendererParams } from 'ag-grid-community';
import { Space } from 'antd';
import { Dictionary } from 'lodash';
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { ProjectId } from 'api/models';
import { Project } from 'api/project';
import { Avatar } from 'components/atoms/avatar';
import { getProjectDetailUrl } from 'utils/urls';

const StyledLink = styled(Link)({
  color: 'initial',
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  '&:hover': {
    color: 'initial',
  },
});

type CellRendererParamtypes = {
  projectsMap: Dictionary<Project>;
};

export const FormProjectNameRenderer = (
  params: ICellRendererParams & CellRendererParamtypes,
) => {
  const { value, projectsMap } = params;
  const projectData = projectsMap ? projectsMap[parseInt(value, 10)] : null;

  return projectData ? (
    <StyledLink to={getProjectDetailUrl(ProjectId(projectData.projectId))}>
      <Space size="small">
        <Avatar
          src={projectData.customer.companyLogoUrl}
          name={projectData.customer.companyName}
        />
        <div>{projectData.projectName}</div>
      </Space>
    </StyledLink>
  ) : null;
};
